import { render, staticRenderFns } from "./link-opportunity-popup.vue?vue&type=template&id=27d08591&"
import script from "./link-opportunity-popup.vue?vue&type=script&lang=js&"
export * from "./link-opportunity-popup.vue?vue&type=script&lang=js&"
import style0 from "./link-opportunity-popup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports